module.exports = __webpack_public_path__ + "img/goal-14.ba931e31.png";